module.exports = __webpack_public_path__ + "static/media/mobile.86c60c4e.png";